module.exports = __webpack_public_path__ + "img/notion.95162eb3.svg";